import { render, staticRenderFns } from "./KeywordTrends.vue?vue&type=template&id=685cf899&scoped=true"
import script from "./KeywordTrends.vue?vue&type=script&lang=js"
export * from "./KeywordTrends.vue?vue&type=script&lang=js"
import style0 from "./KeywordTrends.vue?vue&type=style&index=0&id=685cf899&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685cf899",
  null
  
)

export default component.exports